import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import PageMeta from '../components/PageMeta';
import Reveal from '../components/Reveal';
import ComparisonTable from '../components/ComparisonTable';
import { CheckList, FinalCTA, PageHero, SectionHeading } from '../components/SharedSections';

const { FiPhone, FiVideo, FiMessageCircle, FiFileText, FiMic, FiClipboard, FiBarChart2, FiGitBranch } = FiIcons;

function UCaaS() {
  const schema = { '@context': 'https://schema.org', '@type': 'Service', name: 'UCaaS Advisory', provider: { '@type': 'Organization', name: 'Cambia Digital' }, areaServed: 'New York Tri-State Area' };
  const aiFeatures = [
    [FiMic, 'Call transcription', 'Searchable records of customer and team conversations without manual notes.'],
    [FiClipboard, 'Meeting summaries', 'Action items and decisions captured automatically so work keeps moving.'],
    [FiBarChart2, 'AI analytics', 'Surface trends, sentiment, coaching signals, and operational patterns faster.'],
    [FiGitBranch, 'Intelligent routing', 'Use context and intent to connect callers with the right resource.']
  ];

  return (
    <>
      <PageMeta title="UCaaS Consulting & Provider Comparison" description="Compare cloud business phone and unified communications platforms with an independent advisor." schema={schema} />
      <PageHero eyebrow="Unified Communications as a Service" title="One platform for every business conversation." text="Replace fragmented phone hardware with cloud calling, video, team messaging, fax, and mobility—selected around your business, not a vendor pitch.">
        <div className="hero-check-card"><h2>A simpler communications stack</h2><CheckList items={['Business calling on any device', 'Video meetings and team chat', 'Central administration and reporting', 'Scalable users, locations, and features']} /></div>
      </PageHero>
      <section className="section">
        <Reveal><SectionHeading eyebrow="UCaaS in plain English" title="Your office phone system, built for work that happens everywhere." text="UCaaS puts calling, meetings, messaging, fax, and administration in one cloud service. Employees keep one business identity across desk phones, computers, and mobile devices." center /></Reveal>
        <div className="card-grid four">
          {[[FiPhone, 'Calling'], [FiVideo, 'Video'], [FiMessageCircle, 'Team chat'], [FiFileText, 'Digital fax']].map(([icon, title]) => <Reveal className="mini-feature" key={title}><SafeIcon icon={icon} /><h3>{title}</h3></Reveal>)}
        </div>
      </section>
      <section className="section tint">
        <Reveal><SectionHeading eyebrow="Provider comparison" title="The same checkmarks can hide very different experiences." text="Features and user minimums change. We verify current availability, plan requirements, integrations, support, and total cost before recommending a platform." /></Reveal>
        <Reveal><ComparisonTable /></Reveal>
        <p className="table-note">Comparison is directional and designed for easy updates. Confirm current plan-level availability with an advisor.</p>
      </section>
      <section className="section">
        <Reveal><SectionHeading eyebrow="Modern buying criteria" title="AI features that matter most for SMBs." text="Useful AI should reduce admin work, improve visibility, and help teams respond faster—not become another feature bundle nobody uses." center /></Reveal>
        <div className="card-grid four">
          {aiFeatures.map(([icon, title, text]) => <Reveal className="solution-card" key={title}><div className="icon-tile"><SafeIcon icon={icon} /></div><h3>{title}</h3><p>{text}</p></Reveal>)}
        </div>
      </section>
      <FinalCTA title="Find the UCaaS platform that fits—not simply the one with the loudest pitch." />
    </>
  );
}

export default UCaaS;